import TokenRepo from "../../repos/token.repo";
import { factoryRuntimeSettings } from "../../stores/factory-runtime-settings.store";

export type LlmProviderId = "deepseek" | "cerebras";

/** Model Cerebras cố định cho trợ lý (Qwen 3 235B) */
export const DEFAULT_CEREBRAS_MODEL = "qwen-3-235b-a22b-instruct-2507";

export interface ResolvedLlmConfig {
  baseUrl: string;
  model: string;
  apiKey: string;
  envKeyName: string;
}

export interface ResolveLlmOptions {
  cerebrasModel?: string;
}

export function resolveLlmConfig(
  provider: LlmProviderId,
  options?: ResolveLlmOptions
): ResolvedLlmConfig {
  const cerebras = provider === "cerebras";
  const enabled = factoryRuntimeSettings.boolean(cerebras ? "aiCerebrasEnabled" : "aiDeepseekEnabled");
  return {
    baseUrl: `${(process.env.REACT_APP_API_URL || "").replace(/\/$/, "")}/api/FactoryAssistant/${provider}`,
    model: factoryRuntimeSettings.string(cerebras ? "aiCerebrasModel" : "aiDeepseekModel", cerebras ? DEFAULT_CEREBRAS_MODEL : "deepseek-chat"),
    // This is the user's API session. Provider credentials remain on the server.
    apiKey: enabled ? new TokenRepo().getToken() || "" : "",
    envKeyName: "Quản trị hệ thống → Cấu hình nhà máy và tích hợp → Trợ lý AI",
  };
}
